import { firstValueFrom, Subject } from 'rxjs';
export class SceneContext {
    constructor() {
        this.animationInProgress = false;
        this.animationInStart$ = new Subject();
        this.animationInEnd$ = new Subject();
        this.animationOutStart$ = new Subject();
        this.animationOutEnd$ = new Subject();
    }
    get animationInStart() {
        return firstValueFrom(this.animationInStart$);
    }
    get animationInEnd() {
        return firstValueFrom(this.animationInEnd$);
    }
    get animationOutStart() {
        return firstValueFrom(this.animationOutStart$);
    }
    get animationOutEnd() {
        return firstValueFrom(this.animationOutEnd$);
    }
    animationInStartNext() {
        this.animationInProgress = true;
        this.animationInStart$.next();
    }
    animationInEndNext() {
        this.animationInProgress = false;
        this.animationInEnd$.next();
    }
    animationOutStartNext() {
        this.animationInProgress = true;
        this.animationOutStart$.next();
    }
    animationOutEndNext() {
        this.animationInProgress = false;
        this.animationOutEnd$.next();
    }
}
//# sourceMappingURL=scene-context.js.map